class RemoteAreaManager {

    constructor() {

        this.feeVariantId = 47540777877653;

        this.postcodeInput =
            document.querySelector("#remote-postcode");

        this.messageBox =
            document.querySelector("#remote-area-message");

        this.checkoutButton =
            document.querySelector(
                "button[name='checkout'], input[name='checkout']"
            );

    }



    async init() {


        if (!this.postcodeInput) {
            return;
        }

        this.toggleCheckoutButton(false);

        const cart = await this.getCart();


        const savedPostcode =
            cart.attributes?.["Delivery Postcode"];


        if(savedPostcode){

            this.postcodeInput.value =
                savedPostcode;

            await this.validate(savedPostcode);

        }


        this.postcodeInput.addEventListener(
            "input",
            async () => {

                await this.validate(
                    this.postcodeInput.value.trim()
                );

            }
        );


    }

    toggleCheckoutButton(enabled) {

        if (!this.checkoutButton) {
            return;
        }


        this.checkoutButton.disabled = !enabled;


        if (enabled) {

            this.checkoutButton.classList.remove(
                "disabled"
            );

        } else {

            this.checkoutButton.classList.add(
                "disabled"
            );

        }

    }

    async validate(postcode){

        this.toggleCheckoutButton(false);

        if (!/^\d{4}$/.test(postcode)) {

            this.showMessage(
                "Please enter a valid 4 digit Australian postcode."
            );

            this.toggleCheckoutButton(false);

            return;

        }

        if(!postcode){

            this.showMessage(
                "Please enter your delivery postcode before checkout."
            );

            return;

        }



        if(window.remotePostcodes[postcode]){


            this.showMessage(
                "⚠ Remote Area Delivery Fee Applied (AUD 40)"
            );

            this.toggleCheckoutButton(true);

            await this.addFee();


            await this.saveAttributes(
                postcode,
                "YES"
            );

        }
        else{


            this.showMessage(
                "✓ Standard Delivery Area"
            );

            this.toggleCheckoutButton(true);

            await this.removeFee();


            await this.saveAttributes(
                postcode,
                "NO"
            );      

        }


    }



    async addFee(){


        const cart =
            await this.getCart();



        const exists =
            cart.items.some(
                item =>
                item.variant_id ==
                this.feeVariantId
            );



        if(exists){
            return;
        }



        await fetch(
            "/cart/add.js",
            {

            method:"POST",

            headers:{
                "Content-Type":
                "application/json"
            },

            body:JSON.stringify({

                items:[
                    {
                    id:this.feeVariantId,
                    quantity:1,
                    properties:{
                        "_remote_area_fee":"true"
                    }
                    }
                ]

            })

            }
        );


        await this.refreshCart();


    }



    async removeFee(){


        const cart =
            await this.getCart();



        const fee =
            cart.items.find(
                item =>
                item.variant_id ==
                this.feeVariantId
            );



        if(!fee){
            return;
        }



        await fetch(
            "/cart/update.js",
            {

            method:"POST",

            headers:{
                "Content-Type":
                "application/json"
            },


            body:JSON.stringify({

                updates:{
                    [fee.key]:0
                }

            })

            }
        );


        await this.refreshCart();

    }



    async saveAttributes(postcode,remote){


        await fetch(
            "/cart/update.js",
            {

            method:"POST",

            headers:{
                "Content-Type":
                "application/json"
            },


            body:JSON.stringify({

                attributes:{

                    "Delivery Postcode":
                    postcode,


                    "Remote Area":
                    remote

                }

            })

            }
        );

    }



    async getCart(){

        const response =
            await fetch("/cart.js");


        return await response.json();

    }



async refreshCart() {

    const sections = [
        "main-cart-items",
        "main-cart-footer"
    ];


    const response = await fetch(
        `/cart?sections=${sections.join(",")}`
    );


    const data = await response.json();



    sections.forEach(section => {


        const html =
            data[section];


        const container =
            document.querySelector(
                `#shopify-section-${section}`
            );


        if(container && html){

            container.innerHTML =
                new DOMParser()
                .parseFromString(
                    html,
                    "text/html"
                )
                .querySelector(
                    `#shopify-section-${section}`
                )
                .innerHTML;

        }


    });


}



    showMessage(text){

        if(this.messageBox){

            this.messageBox.innerHTML =
            text;

        }

    }

}



document.addEventListener(
"DOMContentLoaded",
()=>{


    if(window.remotePostcodes){

        const manager =
        new RemoteAreaManager();


        manager.init();

    }


});